let /* graphicLayer, */ graphicLayer2, roamLine;
let isStarted = false;

//const CustomRoamingPerspective = () => import('../customRoaming/customRoamingPerspective/CustomRoamingPerspective.vue');

//按需加载
import {
  selectRoaming,
  selectRoamingPoint,
  deleteFile,
} from "../../../api/api";

import axios from "axios";

export default {
  components: {
    //CustomRoamingPerspective
  },
  props: {},
  data() {
    return {
      routeRoaming_show: true,
      radioValue: "",
      currentPage: 1, //当前分页展示页码。
      prevPage: 1, //跳转到点位面板前漫游路径名称面板里的当前页码，方便跳转回来时该页码不变。
      paginationShow: false, //解决换Tab页时的页码显示不正确的bug。
      pageSize: 10, //当前表格每页展示的数据条数。
      totalRows: 0, //数据总条数。
      tableData: [],
      //参数单位是千米/每小时，所以value需要换算一下，方便直接用。
      options: [
        {
          name: "60 公里/小时",
          value: 60,
        },
        {
          name: "80 公里/小时",
          value: 80,
        },
        {
          name: "100 公里/小时",
          value: 100,
        },
        {
          name: "120 公里/小时",
          value: 120,
        },
        {
          name: "200 公里/小时",
          value: 200,
        },
        // {
        //   name: "20 公里/小时",
        //   value: 20,
        // },
        // {
        //   name: "50 公里/小时",
        //   value: 50,
        // },

        // {
        //   name: "100 公里/小时",
        //   value: 100,
        // },
        // {
        //   name: "200 公里/小时",
        //   value: 200,
        // },
        // {
        //   name: "500 公里/小时",
        //   value: 500,
        // },
        // {
        //   name: "1000 公里/小时",
        //   value: 1000,
        // },
        // {
        //   name: "2000 公里/小时",
        //   value: 2000,
        // },
        // {
        //   name: "5000 公里/小时",
        //   value: 5000,
        // },
      ],
      showPath: true,
      speedChoose: 100,
      prevSpeed: 100, //方便算倍率。
      //open_roaming_box: '', //当前打开的漫游子弹窗，最多只同时显示一个子弹窗。
      camera: {
        //Type: "gs", //'dy', //视角设置参数：视角模式类型。
        //Radius: 20, //'gs'跟随视角时的 初始俯仰距离值（单位：米）
        Type: "dy",
        FollowedX: 15, //视角设置参数：锁定第一视角时，距离运动点的距离（后方）。
        FollowedZ: 2.5, //视角设置参数：锁定第一视角【dy】或平面视角【sd】时，距离运动点的高度（上方）。
        //closeToTerrain:false,
      },
      paused: false, //是否按下了暂停按钮
      isFold: false, //是否最小化
      isRowChange: false, //选择漫游路径改变
      form: {
        fileList: [], //upload多文件数组
      },
      manualFreed_time: null,
    };
  },
  mounted() {
    /* if(!graphicLayer){
			graphicLayer = new mars3d.layer.GraphicLayer();
			this.$GLOBAL.map.addLayer(graphicLayer);
		} */
    if (!graphicLayer2) {
      graphicLayer2 = new mars3d.layer.GraphicLayer(); //飞行漫游矢量图层，避免影响其它图层展示。
      this.$GLOBAL.map.addLayer(graphicLayer2);
    }
    this.initData();

    let that = this;
    document.onkeydown = function (e) {
      if (e.code === "Space" || e.code === "Enter") {
        if (roamLine) {
          if (roamLine.isPause) {
            //继续
            that.release();
            that.routeRoaming_continue();
          } else {
            if (roamLine.isStart) {
              //暂停
              that.clear_release();
              that.routeRoaming_pause();
            } else {
              that.routeRoaming_begin();
            }
          }
        } else {
          that.$alert(
            "勾选表格中的漫游路线，单击地图后即可用空格键控制漫游的暂停与继续哦~",
            "友情提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {},
            }
          );
          return false;
        }
      }
    };
  },
  methods: {
    handleChange(file, fileList) {
      //文件状态改变【添加文件、上传成功、上传失败】时调用此方法。
      // 下面这样写会导致一次上传一个以上的文件时，最后一个文件被删除并提示"当前文件已经存在"，所以先注释。
      // let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
      // if (existFile) {
      // 	this.$message.error('当前文件已经存在！');
      // 	fileList.pop();
      // }

      this.form.fileList = fileList;
      //只保留最后上传的三个文件。
      //this.fileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      //文件验证【后缀名|文件类型、文件大小】应该写在这里。

      //不允许上传同名文件。如果后面改为允许的话，要注意排查删除同名文件的问题【根据名字找文件得改为根据文件id来找文件】。
      let existFile = this.form.fileList
        .slice(0, this.form.fileList.length - 1)
        .find((f) => f.name === file.name);
      if (existFile) {
        this.$message.error(
          "您上传了同名文件：" + file.name + "，已为您移除。"
        );
        return false;
      }

      // console.log(file);
      //避免编辑表单时旧上传文件导致验证不通过。
      //if (file.name) {
      let FileExt = file.name.replace(/.+\./, "");

      /* if (['jpg', 'png', 'txt', 'zip', 'rar', 'pdf', 'doc', 'docx', 'xls', 'xlsx'].indexOf(FileExt
					.toLowerCase()) === -1) {
				this.$message.error('此处只允许上传后缀名为jpg、png、txt、pdf、doc、docx、xls、xlsx、zip或rar的附件！');
				return false;
			} */
      if (["xml"].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message.error("此处只允许上传后缀名为xml的文件！");
        return false;
      }
      //}

      //const fileSizeLimit = this.form.fileList.every(file => file.size / 1024 / 1024 <=5);
      //console.log(this.form.fileList.length);
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error("上传的单个文件大小不能超过10MB！");
        return false;
      }

      //return false; //先return false，阻止默认的给列表添加文件项，上传成功后再调用代码给列表添加文件项。
    },
    uploadFile(param) {
      let that = this;
      let formData = new FormData();
      formData.append("file", param.file);
      //这里如果调用封装的axios流程，会因为header导致一些问题，因此这里直接用axios方法请求上传文件。
      axios
        .post("/baseIP/sysFileInfo/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then(function (res) {
          if (res.data.success && res.data.data) {
            // let fileObj = {
            // 	'name': param.file.name,
            // 	'url': '',
            // 	'id': res.data.data,
            // }
            // that.form.tempFileList.push(fileObj);
            that.form.fileList = that.form.fileList.map((i) => {
              if (i.name === param.file.name) {
                i.id = res.data.data;
              }
              return i;
            });
            param.onSuccess(); //返回promise，调用文件上传成功方法 :on-success="uploadSuccess"
            //return false;

            //获取文件详情
            // let fData={
            // 	id:parseInt(res.data.data)
            // }
            // getFileDetail(fData).then(response => {
            // 	console.log(JSON.parse(JSON.stringify(response)));
            // 	console.log('66666666666')
            // 	if(res.data.success&&res.data.data){
            // 	}
            // }).catch(function(err) {
            //	console.log(err)
            // 	console.log('上传文件失败')
            // })
          } else {
            // console.log(err);
            // console.log('文件 ' + param.file.name + ' 上传失败，请重新上传');
            //上传失败则从列表里删除该项
            that.form.fileList = that.form.fileList.filter((item, index) => {
              return item.name !== param.file.name && item.status !== "ready";
            });
            that.$alert(
              "文件 " + param.file.name + " 上传失败，请重新上传",
              "出错提示",
              {
                type: "error",
              }
            );
            param.onError();
          }
        })
        .catch(function (err) {
          // console.log(err);
          // console.log('上传失败，请重新上传2');

          //上传失败则从列表里删除该项
          that.form.fileList = that.form.fileList.filter((item, index) => {
            return item.name !== param.file.name && item.status !== "ready";
          });

          that.$alert("上传失败，请重新上传", "出错提示", {
            type: "error",
          });
          param.onError();
        });
    },
    handleExceed(files, fileList) {
      //上传文件数量超过限制数量时调用此方法。
      this.$message.warning(
        `最多上传3个文件，您上传了 ${
          files.length + fileList.length
        } 个文件，已超过此数量。`
      );
    },

    beforeRemove(file, fileList) {
      //删除文件前调用，若返回false或者返回Promise且被reject，则停止删除。
      if (file.status !== "ready") {
        this.$confirm(
          "您确定要从服务器删除文件 " + file.name + " 吗？",
          "确认提示",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "确认删除",
            cancelButtonText: "取消删除",
          }
        )
          .then(() => {
            this.handleRemove(file, fileList);
          })
          .catch(function (err) {
            console.log(err);
          });
        // .catch(action => {
        // 	this.$message({
        // 		type: 'info',
        // 		message: action === 'cancel' ?
        // 			'放弃保存并离开页面' : '停留在当前页面'
        // 	})
        // });

        //先return false；阻止默认的删除。在调用服务器删除文件接口成功后再调用handleRemove方法。
        return false;
      }
    },
    handleRemove(file, fileList) {
      let that = this;
      //从文件列表中移除文件时调用此方法。
      let fData = {
        id: file.id,
      };
      deleteFile(fData)
        .then((res) => {
          // console.log(JSON.parse(JSON.stringify(res)));
          // console.log('66666666666'+i)
          if (res.data.success && res.data.code === 204) {
            //alert('触发！');
            let tIndex = fileList.indexOf(file);
            if (tIndex > -1) {
              fileList.splice(tIndex, 1);
              this.form.fileList = fileList;
            }

            // console.log(999999999999999);
            // console.log(JSON.parse(JSON.stringify(file)));
            // console.log(JSON.parse(JSON.stringify(fileList)));
          } else {
            that.$alert("删除失败，请再试一次吧。", "出错提示", {
              type: "error",
            });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    handlePreview(file) {
      let that = this;
      //点击文件列表中已上传的文件时调用此方法，可在此写预览文件内容的代码。
      //['jpg', 'png', 'txt', 'zip', 'rar', 'pdf', 'doc', 'docx', 'xls', 'xlsx']

      //如果是图片则预览，其它符合文件则下载。
      //当然，本页面现在只凭后缀名检测文件并不严谨，但目前先这样。
      let FileExt = file.name.replace(/.+\./, "");
      let fileUrl = "" + file.name;
      if (["jpg", "png"].indexOf(FileExt.toLowerCase()) !== -1) {
        //这里直接使用axios请求上传接口，方便设置responseType: 'blob'。
        axios({
          method: "get",
          url: "/baseIP/sysFileInfo/preview", // 请求地址
          responseType: "blob", // 设置接收格式为blob格式
          params: {
            id: file.id,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        }).then((res) => {
          // console.log(res)
          if (res.status === 200 && res.data) {
            const dataInfo = res.data;
            let reader = new window.FileReader();
            // 使用readAsArrayBuffer读取文件, result属性中将包含一个 ArrayBuffer 对象以表示所读取文件的数据
            reader.readAsArrayBuffer(dataInfo);
            reader.onload = function (e) {
              const result = e.target.result;
              const contentType = dataInfo.type;
              // 生成blob图片,需要参数(字节数组, 文件类型)
              const blob = new Blob([result], {
                type: contentType,
              });
              // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
              const url = window.URL.createObjectURL(blob);
              console.log(url); // 产生一个类似 blob:d3958f5c-0777-0845-9dcf-2cb28783acaf 这样的URL字符串
              that.dialogVisible = true;
              that.dialogImageUrl = url; // 将转换出来的路径赋值给变量，其实和上一步结合就可以
            };
            that.downloadFile(res);
          } else {
            this.$message.error("预览失败，请稍后再试。");
            return false;
          }
        });
      } else {
        //这里直接使用axios请求上传接口，方便设置responseType: 'blob'。
        axios({
          method: "get",
          url: "/baseIP/sysFileInfo/download", // 请求地址
          responseType: "blob", // 设置接收格式为blob格式
          params: {
            id: file.id,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        }).then((res) => {
          // console.log(res)
          if (res.status === 200 && res.data) {
            that.downloadFile(res);
          } else {
            this.$message.error("预览失败，请稍后再试。");
            return false;
          }
        });
      }
    },
    uploadSuccess(reponse, file, fileList) {
      //alert('触发！');
      console.log("触发！");
    },
    routeRoamingBox_close() {
      this.$emit("routeRoamingBox_close");
    },
    routeRoamingBox_fold() {
      if (this.isFold) {
        this.isFold = false;
      } else {
        this.isFold = true;
      }
    },
    routeRoamingBoxFoldPausePlay() {
      if (roamLine.isPause) {
        this.routeRoaming_continue();
      } else {
        this.routeRoaming_pause();
      }
    },
    routeRoaming_begin() {
      // 临时设置允许进入地下。
      //this.$GLOBAL.map.scene.cameraController.enableCollisionDetection = false; // 这样写会报错。
      const options = { highDynamicRange: true, cameraController: {} };
      options.cameraController["enableCollisionDetection"] = false;
      this.$GLOBAL.map.setSceneOptions(options);
      //console.log("更新了地图参数", options);

      let that = this;
      if (!this.radioValue) {
        this.$alert("请先在表格中，选中您想要开始漫游的路线。", "友情提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return false;
      }
      this.isRowChange = false;
      isStarted = true;
      this.searchDataRoaming();
    },
    routeRoaming_pause() {
      if (roamLine) {
        roamLine.pause();
        this.paused = true;
      } else {
        this.$alert("只有开始漫游了，才能暂停哦~", "友情提示", {
          confirmButtonText: "确定",
          type: "warning",
          callback: (action) => {},
        });
      }
    },
    routeRoaming_continue() {
      if (roamLine) {
        roamLine.proceed();
        this.paused = false;
      } else {
        this.$alert("漫游状态出错了，请点击“开始”按钮重新漫游吧~", "友情提示", {
          confirmButtonText: "确定",
          type: "error",
          callback: (action) => {},
        });
      }
    },
    /* rowClick(){
			this.open_roaming_box="CustomRoamingPerspective";
			this.$refs.customRoamingPerspective.initFormData(this.camera);
		}, */
    /* roamingPathF(val) {
			if (val) {
				// console.log('val' + val)
				// console.log('radioValue' + this.radioValue)
				//alert(this.radioValue)
				if (!this.radioValue) {
					this.$alert('请在表格中，选中您想要查看路径的漫游路线。', '友情提示', {
						confirmButtonText: '确定',
						callback: action => {

						}
					});
					return false;
				}
				this.showPath = true;
				this.drawLine(this.radioValue);

			} else {
				graphicLayer.clear();
			}
		}, */
    /* customRoamingPerspectiveChange(params) {
			this.open_roaming_box='';//关闭视角设置弹窗。
			this.camera.Type = params.perspective;
			this.camera.FollowedX = params.perspectiveDistance;
			this.camera.FollowedZ = params.perspectiveHeight;
			if(this.camera.closeToTerrain!==params.closeToTerrain){
				if (this.radioValue) {
					if(roamLine&&(roamLine.isStart||roamLine.isPause)){
						//如果保存切换视角结果中修改了是否贴地选项，则需要重新创建roamLine对象，因为setCameraOptions方法里没有提供修改贴地选项的参数。
						this.searchDataRoaming();
						if(roamLine.isPause){
							//如果保存切换视角结果时roamLine对象是暂停状态，则继续保持暂停状态。
							roamLine.pause();
							this.paused=true;
						}
					}
				}
				this.camera.closeToTerrain = params.closeToTerrain;
			}else{
				let change=false;
				if(roamLine&&roamLine.isStart){
					roamLine.pause();
					change=true;
				}
				//this.camera.closeToTerrain = params.closeToTerrain;
				if (roamLine) {
					roamLine.setCameraOptions({
						// heading:9,
						// pitch:-3,
						type: this.camera.Type,
						radius: this.camera.Type == "gs" ? this.camera.FollowedX : 0,
						followedX: this.camera.FollowedX,
						followedZ: this.camera.FollowedZ,
					})
				}
				if(roamLine&&change){
					roamLine.proceed();
				}
			}
		}, */
    searchDataRoaming() {
      let that = this;
      let searchData = {
        projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
        bimRoamId: this.radioValue,
        sortField: "sort",
        sortOrder: "ascend",
      };
      selectRoamingPoint(searchData).then(function (res) {
        if (res.data.data && res.data.data.length > 0) {
          let pointArr = res.data.data;
          let positionArr = pointArr.map((item) => {
            return [item.x, item.y, item.z];
          });
          if (positionArr && positionArr.length >= 2) {
            let startHeading = parseFloat(pointArr[1]["heading"]) - 90;
            let startPitch = -10; //parseFloat(pointArr[1]['pitch']);
            //设置路径漫游初始视角
            let initX = parseFloat(pointArr[0]["x"]);
            let initY = parseFloat(pointArr[0]["y"]);
            let initZ = parseFloat(pointArr[0]["z"]);
            let initHeading = parseFloat(pointArr[0]["heading"]);
            let initPitch = parseFloat(pointArr[0]["pitch"]);
            if (!isStarted) {
              that.$GLOBAL.map.setCameraView(
                {
                  lng: initX,
                  lat: initY,
                  alt: initZ + 50,
                  heading: initHeading,
                  pitch: initPitch,
                },
                {
                  duration: 2,
                }
              );
            }
            graphicLayer2.clear();
            graphicLayer2.removeGraphic(roamLine);
            roamLine = null;
            let basePathUrl = that.$GLOBAL.localResourcesPath; //window.basePathUrl || "";
            roamLine = new mars3d.graphic.FixedRoute({
              name: "贴地漫游",
              speed: that.prevSpeed, //轨迹速度，单位为千米/小时。
              multiplier: that.speedChoose / that.prevSpeed,
              /* model: {
                //url: "//data.mars3d.cn/gltf/mars/jingche/jingche.gltf",
                url: basePathUrl + "Upload/gltf/mars/car/suv.gltf", //本地版模型
                heading: 0, //startHeading, //0,	//本地版模型
                minimumPixelSize: 50,
                show: true,
              }, */
              positions: positionArr,
              camera: {
                type: that.camera.Type,
                //radius: that.camera.Radius,
                followedX: that.camera.FollowedX,
                followedZ: that.camera.FollowedZ,
                heading: startHeading,
                // pitch: startPitch,
                offsetZ: 1.5,
              },
              hasCache: true, //是否记录缓存。
              clockLoop: true, //是否循环播放
              interpolation: true, //setInterpolationOptions插值
              interpolationDegree: 3,
            });
            graphicLayer2.addGraphic(roamLine);
            /*弹窗漫游提示信息*/
            /* roamLine.bindPopup(`<div style="width: 200px">
						      <div>总 距 离：<span id="lblAllLen"> </span></div>
						      <div>总 时 间：<span id="lblAllTime"> </span></div>
						      <div>开始时间：<span id="lblStartTime"> </span></div>
						      <div>剩余时间：<span id="lblRemainTime"> </span></div>
						      <div>剩余距离：<span id="lblRemainLen"> </span></div>
						    </div>`); */
            // 刷新局部DOM,不影响popup面板的其他控件操作
            roamLine.on(mars3d.EventType.postRender, function (event) {
              const container = event.container; // popup对应的DOM
              const params = roamLine?.info;
              if (!params) {
                return;
              }
              const lblAllLen = container.querySelector("#lblAllLen");
              if (lblAllLen) {
                lblAllLen.innerHTML = mars3d.MeasureUtil.formatDistance(
                  roamLine.alllen
                );
              }

              const lblAllTime = container.querySelector("#lblAllTime");
              if (lblAllTime) {
                lblAllTime.innerHTML = that.formatTime(
                  roamLine.alltimes / that.$GLOBAL.map.clock.multiplier
                );
              }

              const lblStartTime = container.querySelector("#lblStartTime");
              if (lblStartTime) {
                lblStartTime.innerHTML = mars3d.Util.formatDate(
                  Cesium.JulianDate.toDate(roamLine.startTime),
                  "yyyy-M-d HH:mm:ss"
                );
              }

              const lblRemainTime = container.querySelector("#lblRemainTime");
              if (lblRemainTime) {
                lblRemainTime.innerHTML = that.formatTime(
                  (roamLine.alltimes - params.time) /
                    that.$GLOBAL.map.clock.multiplier
                );
              }

              const lblRemainLen = container.querySelector("#lblRemainLen");
              if (lblRemainLen) {
                lblRemainLen.innerHTML = mars3d.MeasureUtil.formatDistance(
                  roamLine.alllen - params.len
                );
              }
            });
            if (!that.isRowChange) {
              that.release();
              roamLine.start();
              roamLine.openPopup(); // 显示popup
              that.isFold = true;
              that.paused = false;
            }
          } else {
            that.$alert(
              "当前该漫游路径的点位数量不足2个，请先点击“点位”按钮添加点位吧。",
              "友情提示",
              {
                confirmButtonText: "确定",
                type: "warning",
                callback: (action) => {},
              }
            );
            that.showPath = false;
            return false;
          }
        } else {
          that.$alert(
            "当前该漫游路径还没有添加点位，请先点击“点位”按钮添加点位吧。",
            "友情提示",
            {
              confirmButtonText: "确定",
              type: "warning",
              callback: (action) => {},
            }
          );
          that.showPath = false;
          return false;
        }
      });
    },
    //动态释放
    release() {
      this.manualFreed_time = setInterval(() => {
        viewShed.manualFreed();
      }, 2000);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.manualFreed_time);
      });
    },
    clear_release() {
      clearInterval(this.manualFreed_time);
    },
    //  格式化时间
    formatTime(strtime) {
      strtime = Number(strtime) || 0;

      if (strtime < 60) {
        return strtime.toFixed(0) + "秒";
      } else if (strtime >= 60 && strtime < 3600) {
        const miao = Math.floor(strtime % 60);
        return (
          Math.floor(strtime / 60) + "分钟" + (miao != 0 ? miao + "秒" : "")
        );
      } else {
        strtime = Math.floor(strtime / 60); // 秒转分钟
        return (
          Math.floor(strtime / 60) + "小时" + Math.floor(strtime % 60) + "分钟"
        );
      }
    },
    /* drawLine(pathId) {
			let that=this;
			if (pathId) {
				let searchData = {
					projectId: parseInt(window.sessionStorage.getItem('nowProjectId')),
					bimRoamId: pathId,
					sortField: 'sort',
					sortOrder: 'descend',
				}
				selectRoamingPoint(searchData).then(function(res) {
					if (res.data.data && res.data.data.length > 0) {
						let pointArr = res.data.data;
						if (pointArr&&pointArr.length >= 2) {
							pointArr = pointArr.map(item => {
								return Cesium.Cartesian3.fromDegrees(item.x, item.y, item.z)
							});
							graphicLayer.clear();
							for (let i = 0; i < pointArr.length - 1; i++) {
								let position = mars3d.PolyUtil.getLinkedPointList(pointArr[i], pointArr[i + 1],
									0, 50);
								let graphic = new mars3d.graphic.PolylineEntity({
									positions: position,
									style: {
										width: 10,
										// 动画线材质
										material: mars3d.MaterialUtil.createMaterialProperty(mars3d
											.MaterialType.LineFlow, {
												color: "#ff0000",
												image: "/img/textures/lineAarrow.png",
												speed: 20,
												repeat: new Cesium.Cartesian2(5, 1)
											}),
										show: true,
										depthFail: true,
										depthFailColor: "#ff0000",
										depthFailMaterial: mars3d.MaterialUtil.createMaterialProperty(
											mars3d.MaterialType.LineFlow, {
												color: "#ff0000",
												image: "/img/textures/lineAarrow.png",
												speed: 20,
												repeat: new Cesium.Cartesian2(5, 1)
											}),
									}
								})
								graphicLayer.addGraphic(graphic);
							}
							//如果正在漫游，则不定位，避免漫游过程中重复勾选此选项导致回到起点。
							if(graphicLayer&&!roamLine.isStart){
								graphicLayer.flyTo();
							}
							
						} else {
							that.$alert('当前该漫游路径的点位数量不足2个，不支持漫游功能哦~', '友情提示', {
								confirmButtonText: '确定',
								type: 'warning',
								callback: action => {}
							});
							that.showPath = false;
							return false;
						}
					}else{
						that.$alert('当前该漫游路径还没有添加点位，暂不支持漫游功能哦~', '友情提示', {
							confirmButtonText: '确定',
							type: 'warning',
							callback: action => {}
						});
						that.showPath = false;
						return false;
					}
				});

			} else {
				that.$alert('参数缺失，无法绘制路径，请再试一次。', '友情提示', {
					confirmButtonText: '确定',
					type: 'error',
					callback: action => {}
				});
				return false;
			}
		}, */
    roamingSpeedChange(value) {
      if (roamLine) {
        let rate = value / this.prevSpeed;
        roamLine.multiplier = rate;
      }
    },
    getCurrentRow(index, row) {
      isStarted = false;
      graphicLayer2.clear();
      this.radioValue = row.id;
      if (this.$GLOBAL.markDrawGraphicLayer) {
        this.$GLOBAL.markDrawGraphicLayer.clear();
      }
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      /* if (this.showPath) {
				this.drawLine(this.radioValue);
			} */
      this.$refs.singleTable.setCurrentRow(row);

      if (roamLine) {
        roamLine.stop();
        roamLine = null;
        this.paused = false;
      }

      //this.open_roaming_box = 'CustomRoamingPerspective';
      //this.$refs.customRoamingPerspective.initFormData(this.camera);
      this.isRowChange = true;
      this.searchDataRoaming();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.initData();
      console.log(`当前页: ${val}`);
    },
    initData() {
      let that = this;
      //获取最新列表数据并展示
      let searchData = {
        projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      selectRoaming(searchData).then(function (res) {
        if (res.data.data.rows && res.data.data.rows.length > 0) {
          that.tableData = res.data.data.rows;
          that.pageSize = res.data.data.pageSize;
          that.currentPage = res.data.data.pageNo;
          that.totalRows = res.data.data.totalRows;
          that.paginationShow = true;
        } else {
          that.tableData = [];
          that.pageSize = 10;
          that.totalRows = 0;
          that.currentPage = 1;
          that.paginationShow = false;
        }
        // console.log(JSON.parse(JSON.stringify(res)));
        // console.log(2222222222);
        //if(that.tableData.length > 0) {
        //	that.radioValue = that.tableData[0].id;
        //that.drawLine(that.radioValue);
        //}
      });
    },
  },
  watch: {},
  destroyed() {
    // this.$GLOBAL.map.removeThing(this.tilesetPlanClip,true) //移除并销毁
    // this.graphicLayer.destroy() //销毁
    if (this.$GLOBAL.markDrawGraphicLayer) {
      this.$GLOBAL.markDrawGraphicLayer.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer, true);
    }
    if (this.$GLOBAL.markDrawGraphicLayer2) {
      this.$GLOBAL.markDrawGraphicLayer2.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer2, true);
    }
    this.$GLOBAL.markDrawGraphicLayer = null;
    this.$GLOBAL.markDrawGraphicLayer2 = null;
    this.$GLOBAL.markDrawGraphicLayerObj = null;
    //this.open_roaming_box='';//关闭关联弹窗。

    /* if (graphicLayer) {
			graphicLayer.clear();
			this.$GLOBAL.map.removeLayer(graphicLayer,true);
			graphicLayer = null;
		} */
    if (graphicLayer2) {
      graphicLayer2.clear();
      this.$GLOBAL.map.removeLayer(graphicLayer2, true);
      graphicLayer2 = null;
    }
    if (roamLine) {
      roamLine.stop();
      roamLine = null;
    }

    // 取消临时设置，恢复为不允许进入地下。
    const options = { highDynamicRange: true, cameraController: {} };
    options.cameraController["enableCollisionDetection"] = true;
    //console.log("更新了地图参数", options);
    this.$GLOBAL.map.setSceneOptions(options);
  },
};
//console.log(localStorage.getItem(ColorPicker));
